/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const BeamsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 43 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190.962745,-1510.975357)">
      <g id="Unstack-Chord" transform="matrix(0.791854,0,0,0.792024,-2358.624908,675.52111)">
        <g transform="matrix(0.442372,-0,-0,0.442372,2126.07379,1054.835014)">
          <g id="backing">
            <path
              d="M2594.747,19.846L2594.747,102.555C2594.747,113.508 2585.852,122.401 2574.896,122.401L2492.196,122.401C2481.241,122.401 2472.346,113.508 2472.346,102.555L2472.346,19.846C2472.346,8.893 2481.241,0 2492.196,0L2574.896,0C2585.852,0 2594.747,8.893 2594.747,19.846Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(0,0.059734,-0.084049,-0,3289.528302,1012.051592)">
          <path
            d="M1518.535,808.967L1228.726,808.967L1228.726,651.738L1518.535,651.738L1518.535,808.967ZM1449.328,701.738L1297.932,701.738L1297.932,758.967L1449.328,758.967L1449.328,701.738Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(0,0.059734,-0.084049,-0,3326.979582,1012.051592)">
          <path
            d="M1518.535,808.967L1228.726,808.967L1228.726,651.738L1518.535,651.738L1518.535,808.967ZM1449.328,701.738L1297.932,701.738L1297.932,758.967L1449.328,758.967L1449.328,701.738Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(0,0.059734,-0.084049,-0,3308.253942,1012.051592)">
          <path
            d="M1518.535,808.967L1228.726,808.967L1228.726,651.738L1518.535,651.738L1518.535,808.967ZM1449.328,701.738L1297.932,701.738L1297.932,758.967L1449.328,758.967L1449.328,701.738Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(1.050581,0,0,1.067523,-162.787703,-74.867748)">
          <g transform="matrix(0.078716,-0,-0,-0.078716,3123.544701,1160.072792)">
            <path
              d="M1333.409,1007.313L1302.414,1019.578L1311.76,1068.469C1318.594,1085.74 1333.661,1098.413 1351.847,1102.188L1385.486,1109.17C1404.574,1113.132 1420.894,1125.414 1429.983,1142.66L1459.35,1198.38L1688.635,1198.38L1596.021,1100.205C1587.267,1090.926 1575.954,1084.455 1563.503,1081.612L1563.489,1081.609C1529.688,1073.951 1504.194,1060.635 1488.808,1039.69C1488.232,1038.901 1487.695,1038.085 1487.183,1037.223L1487.17,1037.201C1486.225,1035.62 1484.565,1032.832 1482.596,1029.521C1482.596,1029.521 1611.937,1030.486 1611.937,1030.485C1621.462,1057.641 1642.41,1071.561 1666.258,1084.09C1696.363,1099.906 1732.086,1113.437 1734.356,1175.198L1734.969,1191.853L1768.28,1190.628L1767.667,1173.973C1765.181,1106.345 1733.018,1082.099 1699.476,1063.868C1688.141,1057.707 1676.599,1052.397 1666.419,1045.843C1654.352,1038.074 1644.379,1028.37 1641.164,1010.923L1638.674,997.41L1423.697,995.614L1438.809,1021.074C1438.809,1021.074 1454.677,1047.81 1458.557,1054.301C1459.59,1056.039 1460.705,1057.727 1461.91,1059.378L1461.923,1059.396C1481.485,1086.043 1513.113,1104.37 1556.1,1114.113C1562.097,1115.483 1567.553,1118.604 1571.774,1123.079L1611.365,1165.046C1611.365,1165.046 1479.461,1165.046 1479.461,1165.046L1459.471,1127.119C1445.742,1101.069 1421.092,1082.516 1392.26,1076.532L1358.622,1069.55C1351.423,1068.056 1345.46,1063.04 1342.755,1056.204L1333.409,1007.313Z"
              style={{ fill: 'white' }}
            />
          </g>
          <g transform="matrix(-0.05687,-0,-0,-0.078716,3339.488037,1129.419746)">
            <path
              d="M2076.741,808.967L1228.726,808.967L1228.726,596.949L2076.741,596.949L2076.741,808.967ZM2007.534,646.949L1297.932,646.949L1297.932,758.967L2007.534,758.967L2007.534,646.949Z"
              style={{ fill: 'white' }}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'BeamsIcon',
);
